import io from 'socket.io-client';
import { useNotifsStore } from '../../stores/Utils/notifs';
import logo from '../../assets/logos/logoX.png';
import { showDesktopNotification } from './browserNotification';

const backendUrl = import.meta.env.VITE_BACKEND_URL;

let socket: any;

const displayNotifDesktop = (titre: string, message: string) => {
  showDesktopNotification(titre, {
    body: message,
    icon: logo,
  });
};

export const initSocket = (userId: string) => {
  if (!backendUrl) {
    console.error('❌ VITE_BACKEND_URL n\'est pas défini');
    return;
  }
  
  try {
    socket = io(backendUrl as string);
    
    socket.on('connect', () => {
      socket.emit('joinRoom', userId);
    });

    socket.on("documentUploaded", (data: any) => {
      useNotifsStore.getState().addNotif(data);
      displayNotifDesktop("Nouveau document !", data.text || "Un document a été ajouté !");
    });

    socket.on("NewChatMessage", (data: any) => {
      useNotifsStore.getState().addNotif(data);
      displayNotifDesktop("Nouveau message !", data.text || "Un nouveau message a été ajouté !");
    })

    socket.on('connect_error', (err: any) => {
      console.error('❌ Erreur de connexion socket:');
    });
    
    socket.on('disconnect', (reason: string) => {
      console.error('🔌 Socket déconnecté:');
    });
    
  } catch (error) {
    console.error('❌ Erreur lors de l\'initialisation du socket:', error);
  }
};

export const leaveRoom = (userId: number) => {
  if (socket && socket.connected) {
    socket.emit('leaveRoom', userId);
    socket.disconnect();
  } else {
    console.error("Le socket n'est pas connecté.");
  }
};